let _ = t => t,
  _t,
  _t2,
  _t3;
import styled from 'styled-components';
import { styledIf, media, breakPoints } from '@ovpn-ui/styles';
import { sidebarAnimation, sidebarWidth, closedSidebarWidth } from '../Navigation/Sidebar/Sidebar.constants';
const transitionMedia = t => {
  var _t$theme$mobileBreakp, _t$theme, _t$theme$tabletBreakp, _t$theme2;
  const mobile = (_t$theme$mobileBreakp = t == null ? void 0 : (_t$theme = t.theme) == null ? void 0 : _t$theme.mobileBreakpoint) != null ? _t$theme$mobileBreakp : breakPoints.XS;
  const tablet = (_t$theme$tabletBreakp = t == null ? void 0 : (_t$theme2 = t.theme) == null ? void 0 : _t$theme2.tabletBreakpoint) != null ? _t$theme$tabletBreakp : breakPoints.SM;
  return media.moreThen((mobile + tablet) / 2);
};
export const PusherContent = styled.div(_t || (_t = _`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 100%;
    height: calc(100% - var(--sidebar-top-offset, 0px));
    margin-top: var(--sidebar-top-offset, 0px);
    padding-left: ${0}px;
    overflow: auto;

    ${0};

    will-change: padding-left;

    ${0}
`), props => props.$open ? sidebarWidth : closedSidebarWidth, props => transitionMedia(props)(_t2 || (_t2 = _`
        transition: padding-left ${0};
    `), sidebarAnimation), styledIf('$isMobile')(_t3 || (_t3 = _`
        margin-top: 41px;
        padding-left: 0;
    `)));